import React from 'react'
import style from './PresenterControlButton.module.scss'
import Button, { ButtonType } from '../Button'
import TooltipWrapper, { TooltipPosition } from '../TooltipWrapper'
import classnames from 'classnames'
import get from 'lodash/get'
import { iconName, colour } from '../Icon/types'
import GrowingIcon from '../GrowingIcon'
import { Size } from '../GrowingIcon/types'
import DisabledIcon from '../DisabledIcon'
import { PresenterControlButtonProps, PresenterControlButtonState } from './types'

class PresenterControlButton extends React.Component<PresenterControlButtonProps, PresenterControlButtonState> {

  constructor (props) {

    super(props)
    this.state = {
      buttonRef: React.createRef<HTMLButtonElement>()
    }

  }

  getTooltipText = (): string => {

    if (this.props.isHidden) return get(this.props, 'tooltipText.hidden', '')
    if (this.props.hasError) return get(this.props, 'tooltipText.errored', '')
    if (!this.props.isHidden && !this.props.hasError) return get(this.props, 'tooltipText.enabled', '')
    return ''

  }

  getIcon = (): iconName => {

    if (this.props.isHidden) return this.props.buttonIcons.hidden
    if (this.props.hasError) return this.props.buttonIcons.errored
    return this.props.buttonIcons.enabled

  }

  getIconColor = (): colour => {

    if (this.props.isHidden) return get(this.props, 'buttonIconColors.hidden.icon', colour.danger)
    if (this.props.hasError) return get(this.props, 'buttonIconColors.errored.icon', colour.white)
    if (this.props.isDisabled) return get(this.props, 'buttonIconColors.disabled.icon', colour.tertiary)
    return get(this.props, 'buttonIconColors.enabled.icon', colour.white)

  }

  getHaloColor = (): colour => {

    if (this.props.isHidden) return get(this.props, 'buttonIconColors.hidden.halo', colour.white)
    if (this.props.hasError) return get(this.props, 'buttonIconColors.errored.halo', colour.lightGrey)
    if (this.props.isDisabled) return get(this.props, 'buttonIconColors.disabled.halo', colour.darkGrey)
    return get(this.props, 'buttonIconColors.enabled.halo', colour.lightGrey)

  }

  getHoveredByDefault = (): boolean | undefined => {

    return this.props.isHidden || this.props.isDisabled
      ? true
      : this.props.showHaloByDefault

  }

  buttonContent = (): JSX.Element => {

    return <div className={classnames(
      style['presenter-control-button__icon_holder'], {
        [style['presenter-control-button_error']]: this.props.hasError
      })}
    >
      <GrowingIcon
        icon={{
          name: this.getIcon(),
          colour: this.getIconColor()
        }}
        size={get(this.props, 'size', Size.REGULAR)}
        haloColor={this.getHaloColor()}
        hovered={this.getHoveredByDefault()}
      />
      {
        this.props.hasError &&
        <div className={style['error_icon_container']} data-bdd='presenter-control-button-input-hidden' ><DisabledIcon /></div>
      }
    </div>

  }

  render () {

    return <TooltipWrapper
        tooltipText={this.getTooltipText()}
        position={this.props.tooltipPosition ? this.props.tooltipPosition : TooltipPosition.TOP}
        data-bdd={this.props.tooltipBdd}>
        <Button
          dataBdd={this.props.buttonBdd}
          innerRef={this.state.buttonRef}
          className={style['presenter-control-button']}
          size={ButtonType.buttonSize.small}
          onClick={this.props.onClick}
        >
          {this.buttonContent()}
        </Button>
      </TooltipWrapper>
  }

}

export default PresenterControlButton
